import Tippy from "./Tippy.vue";
// @ts-ignore
export type { ProvideTippy } from "./Tippy.vue";

export default Tippy;
